import { Module } from "wrapper6";
import $ from 'jquery';

export default class ContactMap extends Module {
  ready() {
    this.AMERICA = document.getElementById('g5367');
    this.DENMARK = document.getElementById('g5367-3');
    this.ASIA_PACIFIC = document.getElementById('g5367-3-7');
    this.highlightTimeout;

    if (document.getElementById('contact-image')) {
      this.init();
    }
  }

  init() {
    if (this.DENMARK) {
      this.DENMARK.addEventListener('click', () => this.highlightDenmark());
    }

    if (this.AMERICA) {
      this.AMERICA.addEventListener('click', () => this.scrollToContact());
    }
    
    if (this.CHINA) {
      this.CHINA.addEventListener('click', () => this.scrollToContact());
    }

    if (this.ASIA_PACIFIC) {
      this.ASIA_PACIFIC.addEventListener('click', () => this.scrollToContact());
    }
  }
  
  scrollToContact() {
    $('html, body').animate({
      scrollTop: $('.so-widget-mtt-country-adress').offset().top - 240
    }, 'normal');
  }

  highlightDenmark() {
    const DK_TITLE = document.querySelector('#contact-image .links h2');

    clearTimeout(this.highlightTimeout);
    DK_TITLE.classList.add('highlight');

    this.highlightTimeout = setTimeout(() => {
      DK_TITLE.classList.remove('highlight');
    }, 4000);
  }
}